import {
  AnyGalleryEntityVersion,
  FirestoreEntity,
  Gallery,
  Logger,
  Mapper,
} from '@uploadcam/common';
import { CollectionReference, doc, getDoc } from 'firebase/firestore';

export class GetGalleryByIdInteractor {
  constructor(
    private readonly collection: CollectionReference<AnyGalleryEntityVersion>,
    private readonly logger: Logger,
    private readonly mapper: Mapper<FirestoreEntity<AnyGalleryEntityVersion>, Gallery>,
  ) {}

  public async execute(galleryId: string): Promise<Gallery | undefined> {
    try {
      const snap = await getDoc(doc(this.collection, galleryId));
      return snap.exists() ? this.mapper.map(FirestoreEntity.from(snap)) : undefined;
    } catch (err) {
      this.logger.error('Failed to load gallery:', err);
      throw err;
    }
  }
}
